module.exports = __webpack_public_path__ + "static/media/modis2973.87494aa0.jpg";